import React, { useMemo } from 'react';
import { CssVarsProvider, extendTheme } from '@mui/joy/styles';
import { useTranslation } from 'react-i18next';
import { isRtlLocale } from '../../../i18n/language';

/**
 * Joy UI theme must match document direction so sx/layout align with RTL (Arabic).
 */
export function JoyDirectionalCssVarsProvider({ children }) {
  const { i18n } = useTranslation();
  const direction = isRtlLocale(i18n.language) ? 'rtl' : 'ltr';
  const theme = useMemo(
    () =>
      extendTheme({
        direction,
        components: {
          JoySnackbar: {
            defaultProps: {
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: direction === 'rtl' ? 'left' : 'right',
              },
            },
          },
        },
      }),
    [direction],
  );
  return <CssVarsProvider theme={theme}>{children}</CssVarsProvider>;
}
